import React from "react";
import "./MapStyleToggle.css";

const MapStyleToggle = ({ currentStyle, onStyleChange }) => {
  // Toggle between 'default' and 'monochrome' styles
  const toggleStyle = () => {
    const newStyle = currentStyle === "default" ? "monochrome" : "default";
    onStyleChange(newStyle);
  };

  return (
    <div
      className="map-style-toggle-button"
      onClick={toggleStyle}
      title={
        currentStyle === "default"
          ? "Switch to Monochrome"
          : "Switch to Standard"
      }
    >
      {/* Show the opposite icon of the current style */}
      <div
        className={`map-style-icon ${
          currentStyle === "default"
            ? "map-icon-monochrome"
            : "map-icon-default"
        }`}
      ></div>
    </div>
  );
};

export default MapStyleToggle;
